export default __webpack_public_path__ + "static/media/github.013eec4a.svg";